import React from 'react';
import { DefaultWidgetWithHeader } from '../../_lib/components/Widget';
import { Widget as WidgetShape } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { OrgUnitMembershipsBlock, isOrgUnitMembershipsBlock } from '../../_blocks/OrgUnitMemberships';
import { Icons } from '../../components/atoms/SVG';
import { isEmptyBlock } from '../../types/api/Block';
import { useSonTranslation } from '../../translation/useSonTranslation';

export type OrgUnitMembershipsWidget = WidgetShape<[OrgUnitMembershipsBlock], WidgetType.orgunitMemberships>;

/**
 * OrgUnitMemberships Widget used in PersonalProfile Page.
 */
export function OrgUnitMembershipsWidget({ blocks, elementType, ...headerProps }: OrgUnitMembershipsWidget) {
  const { t } = useSonTranslation('ConnectedOrgUnits');

  const orgUnitMembershipsBlock = blocks.find(isOrgUnitMembershipsBlock);

  if (orgUnitMembershipsBlock && isEmptyBlock(orgUnitMembershipsBlock)) {
    return null;
  }

  return (
    <DefaultWidgetWithHeader
      {...headerProps}
      widgetType={elementType}
      icon={Icons.ORGANISATION}
      title={t('widgetTitle')}
    >
      {orgUnitMembershipsBlock && <OrgUnitMembershipsBlock {...orgUnitMembershipsBlock} />}
    </DefaultWidgetWithHeader>
  );
}
